<template lang='pug'>
  div
    v-container(fill-height v-if='loading')
      v-row(align='center' justify='center')
        bionic-metrics-spinner
    v-container(fluid grid-list-lg v-if='!loading')
      v-row(wrap)
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#accountsCard.super-admin-card(@click="to('/super/accounts')")
            v-card-title.text-h5.font-weight-light Accounts
            v-card-text.text-center
              .text-h2.primary--text {{accountCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/accounts') View Accounts
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#usersCard.super-admin-card(@click="to('/super/users')")
            v-card-title.text-h5.font-weight-light Users
            v-card-text.text-center
              .text-h2.primary--text {{userCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/users') View Users
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#testsCard.super-admin-card(@click="to('/super/tests')")
            v-card-title.text-h5.font-weight-light Tests
            v-card-text.text-center
              .text-h2.primary--text {{testCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/tests') View Tests
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#suitesCard.super-admin-card(@click="to('/super/suites')")
            v-card-title.text-h5.font-weight-light Suites
            v-card-text.text-center
              .text-h2.primary--text {{suiteCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/suites') View Suites
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#transientsCard.super-admin-card(@click="to('/super/transients')")
            v-card-title.text-h5.font-weight-light Transients
            v-card-text.text-center
              .text-h2.primary--text {{transientCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/transients') View Transients
        v-col(cols='12' sm='6' md='4' lg='3')
          v-card#agentsCard.super-admin-card(@click="to('/super/agents')")
            v-card-title.text-h5.font-weight-light Agents
            v-card-text.text-center
              .text-h2.primary--text {{agentCount}}
            v-card-actions
              v-spacer
              v-btn(text color='primary' to='/super/agents') View Agents
</template>

<script>
import {mapGetters, mapActions} from 'vuex';
import SuperAdmin from '../../../api/superAdmin';
import BionicMetricsSpinner from '../../../components/Spinner';

export default {
  name: 'SuperAdminDashboard',
  components: {
    BionicMetricsSpinner
  },
  async mounted() {
    this.loading = true;
    await this.getServerVersion();
    this.loading = false;
  },
  computed: {
    ...mapGetters({
      serverVersion: 'getServerVersion',
      appVersion: 'getAppVersion'
    })
  },
  asyncComputed: {
    async accountCount() {
      const {total} = await SuperAdmin.getAccounts({limit: 0});
      return total;
    },
    async userCount() {
      const {total} = await SuperAdmin.getUsers({limit: 0});
      return total;
    },
    async testCount() {
      const {total} = await SuperAdmin.getTests({limit: 0});
      return total;
    },
    async suiteCount() {
      const {total} = await SuperAdmin.getTestSuites({limit: 0});
      return total;
    },
    async transientCount() {
      const {total} = await SuperAdmin.getTransients({limit: 0});
      return total;
    },
    async agentCount() {
      const {total} = await SuperAdmin.getAgents({limit: 0});
      return total;
    }
  },
  methods: {
    to(route) {
      this.$router.push(route);
    },
    ...mapActions({
      getServerVersion: 'getServerVersion'
    })
  },
  data() {
    return {
      loading: false
    };
  }
};
</script>

<style scoped>
.super-admin-card {
  height: 100%;
}
</style>
